var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "column-edit-size" },
    [
      _c("el-input-number", {
        attrs: {
          controls: false,
          precision: _vm.precision,
          min: _vm.min,
          max: _vm.max,
          size: "mini",
          "data-index": "sizeLength"
        },
        on: { change: _vm.handleChange },
        model: {
          value: _vm.sizeLength,
          callback: function($$v) {
            _vm.sizeLength = $$v
          },
          expression: "sizeLength"
        }
      }),
      _c("span", [_vm._v("*")]),
      _c("el-input-number", {
        attrs: {
          controls: false,
          precision: _vm.precision,
          min: _vm.min,
          max: _vm.max,
          size: "mini",
          "data-index": "sizeWidth"
        },
        on: { change: _vm.handleChange },
        model: {
          value: _vm.sizeWidth,
          callback: function($$v) {
            _vm.sizeWidth = $$v
          },
          expression: "sizeWidth"
        }
      }),
      _c("span", [_vm._v("*")]),
      _c("el-input-number", {
        attrs: {
          controls: false,
          precision: _vm.precision,
          min: _vm.min,
          max: _vm.max,
          size: "mini",
          "data-index": "sizeHeight"
        },
        on: { change: _vm.handleChange },
        model: {
          value: _vm.sizeHeight,
          callback: function($$v) {
            _vm.sizeHeight = $$v
          },
          expression: "sizeHeight"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }